import React from 'react';
import { Skeleton } from "../../../skeleton/Skeleton.js";
import { Typography } from "../../../typography/Typography.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomTypography({
  element,
  isLoading
}) {
  if (isLoading) {
    return /*#__PURE__*/_jsx(Skeleton, {
      lines: 1,
      width: "150px",
      marginBottom: element.componentProps.margin ? '0px' : '35px',
      display: "flex"
    });
  }
  return /*#__PURE__*/_jsx(Typography, {
    ...element.componentProps
  });
}